// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--1DwIZ";
export var btnPrimary = "Button-module--btnPrimary--2i6-I";
export var btnLink = "Button-module--btnLink--19y_M";
export var iconArrow = "Button-module--iconArrow--19mvu";